import React from 'react';

function Warning(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none" 
            className={className}
        >
            <path 
                d="M7.61547 4.9648C7.65031 4.92995 7.69262 4.91253 7.7424 4.91253H8.36213C8.41689 4.91253 8.4592 4.92995 8.48907 4.9648C8.52391 4.99964 8.54133 5.04195 8.54133 5.09173V8.616C8.54133 8.66578 8.52391 8.70809 8.48907 8.74293C8.4592 8.77778 8.41689 8.7952 8.36213 8.7952H7.7424C7.69262 8.7952 7.65031 8.77778 7.61547 8.74293C7.58062 8.70809 7.5632 8.66578 7.5632 8.616V5.09173C7.5632 5.04195 7.58062 4.99964 7.61547 4.9648Z" 
                fill={fill}
            />
            <path 
                d="M7.57813 10.3571C7.61298 10.3273 7.65778 10.3123 7.71253 10.3123H8.392C8.44676 10.3123 8.49156 10.3273 8.5264 10.3571C8.56124 10.392 8.57867 10.4368 8.57867 10.4915V11.0291C8.57867 11.0789 8.56124 11.1212 8.5264 11.1561C8.49156 11.1909 8.44676 11.2083 8.392 11.2083H7.71253C7.65778 11.2083 7.61298 11.1909 7.57813 11.1561C7.54827 11.1212 7.53333 11.0789 7.53333 11.0291V10.4915C7.53333 10.4368 7.54827 10.392 7.57813 10.3571Z" 
                fill={fill}
            />
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM14.0667 8C14.0667 4.64947 11.3505 1.93333 8 1.93333C4.64947 1.93333 1.93333 4.64947 1.93333 8C1.93333 11.3505 4.64947 14.0667 8 14.0667C11.3505 14.0667 14.0667 11.3505 14.0667 8Z" 
                fill={fill}
            />
        </svg>
    )
};

export default Warning;